export default __webpack_public_path__ + "static/media/MERNG.9c2866b3.png";